import { ROUTES } from './routes.ts';

const NON_CACHEABLE_ROUTES_REGEX = [
  `^${ROUTES.MY_ACCOUNT.ROOT}.*`,
  `^${ROUTES.REGISTER}.*`,
  `^${ROUTES.TIME_OFF}.*`,
  `^${ROUTES.LOTTO.PURCHASES}`,
  '^/ob',
  '^/lotteries/.*/results-winning-numbers',
  `^${ROUTES.KENOGO.RESULTS}`,
];

export { NON_CACHEABLE_ROUTES_REGEX };
